export default __webpack_public_path__ + "static/media/E48E7DB8-7486-4B56-BFB9-A028607819DC_1_105_c.35ed4ac8.jpg";